// Centraliza rutas para evitar “hardcode” por toda la app
export const ENDPOINTS = {
  branches: "/sucursales",
  salesSummary: "/resumen",
  salesByHour: "/por_hora",
  salesByDay: "/por_dia",
  productsRanking: "/ranking",
  customersStats: "/estadisticas",
  ordersByCustomer: "/historial_pedidos",
  avgTicket: "/ticket_promedio",
  cancellations: "/cancelaciones_devoluciones"
};
